import { useList } from '@ztechapps/common.hook'
import type { Order } from '@ztechapps/common.contract'
import { OrderStatusEnum } from '@ztechapps/common.contract'
import { useUser } from './useUser'
import { myOrderIdListQuery } from './useOrder/graphql'

//shared active-quotation check for the order-alert banner and the login dialog
export const useActiveQuotation = () => {
  const { loggedIn } = useUser()

  const filter = {
    status: { $in: [OrderStatusEnum.Quotation, OrderStatusEnum.InProgress, OrderStatusEnum.ReadyForPayment] },
  }

  //fetch only the latest active quotation — existence drives the banner/dialog, the id drives the deep-link
  const { list } = useList<Order>({
    query: myOrderIdListQuery,
    filter,
    sort: { createdAt: -1 },
    limit: 1,
    options: {
      queryOptions: { skip: !loggedIn, fetchPolicy: 'cache-and-network', nextFetchPolicy: 'cache-and-network' },
    },
  })

  const latestQuotationId = list?.[0]?._id

  return { loggedIn, latestQuotationId, hasActiveQuotation: !!latestQuotationId }
}
